import React from 'react';
import { Outlet } from 'react-router-dom';

const AppShell = () => {

  return (
    <div className="min-h-screen bg-white">{/* Removed headers - each page now has its own */}

      {/* Main Content */}
      <main>
        <Outlet />
      </main>

    </div>
  );
};

export default AppShell;